<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>
      <header>

        <div class="header" v-if="datas.business.logo">
          <div class="logo"><img :src="datas.business.logo" /></div>
          <div class="phone" v-if="datas.business.linkphone"><a :href="'tel:'+datas.business.linkphone">一键拨号</a></div>
        </div>

        <!-- 焦点图 -->
        <div class="MainBox">
          <viewer @inited="inited" ref="viewer">
            <div class="swiper-container banner">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1"
                  v-for="(item, index) in datas.focus" v-bind:key="index">
                  <a :href="item.url" target="_blank"><img :src="item.img"></a>
                </div>
              </div>
            </div>
          </viewer>
        </div>
      </header>

      <section>

        <!-- 防伪验证 -->
        <div class="MainBox" v-if="datas.verify && datas.antifake_is_show == '1'">
          <div class="MainTitle">防伪验证</div>
          <div class="MainDatasBox">
            <p class="inputBox">
              <a class="inputBoxMain"><input type="text" v-model="vcode" placeholder="请在这里输入防伪码"
                  @keyup.enter="CodeVerify" /></a>
              <i class="queryIcon" v-on:click="CodeVerify"><img src="../../static/images/query-01.png"></i>
            </p>
          </div>
        </div>

        <!-- 产品信息 -->
        <div class="MainBox" v-if="datas.prod_is_show == 1">
          <div class="MainTitle">产品信息</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-if="datas.prod_name_is_show == 1">产品名称：{{ datas.product.name }}</div>
            <div class="ProductMain">
              <ul class="ProductDatasBox">
                <li v-if="datas.product.img" class="ProductImg backImg" :style="{ backgroundImage: 'url(' + datas.product.img + ')' }"></li>
                <li class="ProductDatas">
                  <p v-if="datas.product.period && datas.prod_name_is_show == 1"><i
                      class="letter">保质期</i>：{{ datas.product.period }}</p>
                  <p v-if="datas.product.unit && datas.prod_name_is_show == 1">商品规格：{{ datas.product.unit }}</p>
                </li>
              </ul>
              <viewer @inited="inited" ref="viewer">
                <ul class="ProductCustom" @inited="inited">
                  <li v-if="code">标签ID：{{ code }}</li>
                  <li v-if="datas.verify && datas.antifake_code_show == '1'">防伪码：{{ datas.verify }}</li>
                  <li v-if="datas.attribute && datas.attribute.ship_date" v-text="'生产日期：' + datas.attribute.ship_date"></li>
                  <li v-if="!isCx">首次扫码时间：{{ datas.scan_first_time }}</li>
                  <li v-if="!isCx">扫码次数：{{ datas.scan_count }}</li>
                  <!-- <li>首次扫码地点：<a v-if="datas.scan_first_address" v-text="datas.scan_first_address"></a><a v-else>正在获取中...</a></li> -->
                  <template v-if="datas.batch_is_show">
                    <li v-if="datas.batch">标签批次：{{ datas.batch.name }}</li>
                    <li v-else>标签批次：{{ datas.plan_id }}</li>
                  </template>
                  <template v-for="val in datas.product.attribute">
                    <li :class='{"topNo": val.value && (val.value.substring(val.value.length - 3) === "jpg" || val.value.substring(val.value.length - 3) === "png")}' v-if="datas.product.attribute">
                      <img v-if='val.value && (val.value.substring(val.value.length - 3) === "jpg" || val.value.substring(val.value.length - 3) === "png")' class="img-box" :src="val.value" />
                      <a v-else>{{ val.key }}{{ val.value }}</a>
                    </li>
                  </template>
                  <li v-if="datas.product.introduce && datas.prod_name_is_show == 1">商品描述：{{ datas.product.introduce }}</li>
                </ul>
              </viewer>
            </div>
          </div>
        </div>

        <!-- 质检信息 -->
        <div class="MainBox" v-if="datas.batch && datas.batch_is_show == 1 && datas.batch.qc">
          <div class="MainTitle">质检信息</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-for="(item, index) in datas.batch.qc" v-bind:key="index">
              <p v-if="item.ix == 0">{{ item.key }}：{{ item.value }}</p>
              <p v-else><i class="qckey">{{ item.key }}：</i><img class="qcImg" :src="item.value"></p>
            </div>
          </div>
        </div>

        <!-- 商户信息-武汉剑桥树商贸有限公司-定制 -->
        <div class="MainBox" v-if="datas.business && datas.business.rootid == '100010122' && datas.business_is_show == 1">
          <div class="MainTitle">公司信息</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow">公司名称：{{ datas.business.name }}</div>
            <div class="MainDatasRow" v-if="datas.business.baddress">公司地址：{{ datas.business.baddress }}</div>
            <div class="MainDatasRow" v-if="datas.business.intro">公司简介：{{ datas.business.intro }}</div>
            <div class="MainDatasRow" v-if="datas.business.customize_data" v-for="val in datas.business.customize_data"
              v-text="val.key + '：' + val.value"></div>
          </div>
        </div>

        <div class="MainBox" v-else-if="datas.business && datas.business_is_show == 1">
          <div class="MainTitle">商户信息</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow">商户名称：{{ datas.business.name }}</div>
            <div class="MainDatasRow" v-if="datas.business.linkman && datas.business.rootid != '100010148'"><i class="letter">联系人</i>：{{ datas.business.linkman }}
            </div>
            <div class="MainDatasRow" v-if="datas.business.linkphone && datas.business.rootid != '100010148'">联系电话：{{ datas.business.linkphone }}</div>
            <div class="MainDatasRow" v-if="datas.business.baddress">商户地址：{{ datas.business.baddress }}</div>
            <div class="MainDatasRow" v-if="datas.business.intro">公司简介：{{ datas.business.intro }}</div>
            <viewer @inited="inited" ref="viewer">
              <div v-if="datas.business.customize_data">
                <template v-for="val in datas.business.customize_data">
                  <img v-if='val.value && (val.value.substring(val.value.length - 3) === "jpg" || val.value.substring(val.value.length - 3) === "png")' class="img-box" :src="val.value" />
                  <div class="MainDatasRow" v-else>{{ val.key }}{{ val.value }}</div>
                </template>
              </div>
            </viewer>
          </div>
        </div>

        <!-- 生产流程 -->
        <div class="MainBox" v-if="datas.process && datas.process_is_show == 1">
          <div class="MainTitle">生产流程</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-for="(item, index) in datas.process" v-bind:key="index">
              <p>{{ index + 1 }}.{{ item.name }}：{{ item.date.substring(0, 10) }}</p>
            </div>
          </div>
        </div>

        <!-- 生产流程演示 -->
        <div class="MainBox"
          v-if="datas.process_demo && datas.process_demo.length > 0 && datas.process_demo_is_show == 1">
          <div class="MainTitle">生产流程</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-for="(item, index) in datas.process_demo" v-bind:key="index">
              <p>{{ index + 1 }}.{{ item.name }}：{{ item.date }}</p>
            </div>
          </div>
        </div>

        <!-- 经销商流程-北京华千新技术有限公司-定制 -->
        <div class="MainBox" v-if="datas.business.rootid == 100010094 && datas.dealer && datas.dealer_is_show == 1">
          <div class="MainTitle">收货地址</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-for="(item, index) in datas.dealer" v-bind:key="index">
              <p>{{ item.linkaddress }}</p>
            </div>
          </div>
        </div>

        <!-- 经销商流程-标准 -->
        <div class="MainBox" v-if="datas.business.rootid != 100010094 && datas.dealer && datas.dealer_is_show == 1">
          <div class="MainTitle">经销商流程</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow" v-for="(item, index) in datas.dealer" v-bind:key="index">
              <p>{{ index + 1 }}.{{ item.name || item.alias }}：{{ item.date.substring(0, 10) }}</p>
            </div>
          </div>
        </div>

        <!-- 视频信息 -->
        <div class="MainBox" v-if="datas.video && datas.video_is_show == 1">
          <div class="MainTitle">视频信息</div>
          <div class="MainDatasBox">
            <div class="MainDatasRow">
              <video id="VideoBox" class="video-js vjs-big-play-centered vjs-fluid VideoBox"
                :poster="datas.video.url + '?vframe/jpg/offset/1/w/400/'">
                <source :src="datas.video.url" type="video/mp4">
              </video>
            </div>
          </div>
        </div>

        <!-- 自定义栏目 -->
        <viewer @inited="inited" ref="viewer">
          <div class="MainBox" v-if="datas.ref && datas.ref_is_show == 1" v-for="(item, index) in datas.ref"
            v-bind:key="index">
            <div class="MainTitle" v-text="item.name"></div>
            <div class="MainDatasBox swiper-container ref">
              <ul class="MainRefDatasBox swiper-wrapper">
                <li class="swiper-slide" v-for="(val, ix) in item.datas" v-bind:key="ix">
                  <a v-if="val.type == 0" v-text="val.data"></a>
                  <img v-else :src="val.data">
                </li>
              </ul>
            </div>
          </div>
        </viewer>

        <!-- 自定义底部菜单 -->
        <div class="MainBox" v-if="datas.menu && datas.menu_is_show == 1">
          <ul class="MainMenuRow CliclStyle" v-for="(item, index) in datas.menu" v-bind:key="index"
            @click="ClickMenu(item)">
            <li class="MainMenuIcon">
              <i v-if="item.icon" class="backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }"></i>
              <i v-else class="backImg"
                :style="{ backgroundImage: 'url(../../static/images/icon' + item.type + '.png)' }"></i>
              <span class="icon iconfont iconyou MainMenuArrows"></span>
            </li>
            <li class="MainMenuDatas">
              <p class="MainMenuDatasTit onlyOneRow" v-text="item.name"></p>
              <p class="MainMenuDatasTxt onlyOneRow" v-text="item.describe"></p>
            </li>
          </ul>
        </div>

        <!-- 提示框 -->
        <section id="MaskedBlock" v-if="hintTxt">
          <i class="Masked"></i>
          <div class="ToolTip">
            <ul>
              <li>{{ datas.business.name }}</li>
              <li class="MaskedMain" v-text="hintTxt"></li>
              <li class="confirm" v-on:click="CloseTip">确定</li>
            </ul>
          </div>
        </section>

      </section>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
import Speaker from '../hook/auto.js'
export default {
  name: 'Normal03',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      datas: null,
      hintTxt: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      Music: {
        url: null,
        type: false
      },
      isCx: false, //是否是从促销进入
      queryContent: '',
    }
  },
  created() {
    self = this;
    document.querySelector('body').setAttribute('style', 'background-color:#FFF');

    //判断是否从促销进入
    const params = this.GetParamsNew();
    if(params && params.type === 'cx'){
      this.isCx = true;
    }

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  watch: {
    'datas.video' (nval){
      if (nval) {
        setTimeout(() => {
          this.initVideo(); 
        }, 200);
      }
    }
  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {

          //武汉剑桥商贸公司特殊处理
          if(response.data.meta.activation_id == '136579874000004') {
            self.Loading.type = 3;
            self.Loading.txt = "此防伪码不存在，谨防假冒！";
            return;
          };

          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码
          datas.plan_id = response.data.meta.plan_id; //生码批次

          //自定义防伪查询语句
          if (datas.first_antifake_msg) {
            self.msg = datas.first_antifake_msg;
          }

          //激活自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //发货自定义属性
          if (datas.dealer && datas.dealer.length) {
            datas.attribute = datas.dealer[0].attribute && JSON.parse(datas.dealer[0].attribute);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          self.$nextTick(function () {
            new Swiper('.banner', {
              autoplay: {
                delay: 3000
              },
              autoHeight: true, //高度随内容变化
              loop: true, //可选选项，开启循环
            })

            new Swiper('.ref', {
              watchSlidesProgress: true,
              watchSlidesVisibility: true,
              slidesPerView: 2.4,
              spaceBetween: 10,
            })

          })

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    CodeVerify() {
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.code + "/" + self.vcode)
        .then((response)=> {
          var json = response.data;
          if (json.code == 200) {
            this.queryContent = json.meta;
            let msg;
            // if(this.queryContent.query_count > 1 && !this.datas.many_antifake_msg){
            //   msg = "您查询的码标已经被多次扫描，谨防假冒!";
            // }
            if(!this.datas.first_antifake_msg){
              msg = `您所查询的是 ${self.datas.business.name} 正品，当前查询次数为 ${json.meta.query_count} 次，首次查询时间为 ${json.meta.query_first_time}，感谢查询 ！`;
            }
            if(this.datas.first_antifake_msg){
              msg = this.datas.first_antifake_msg;
            }
            if(this.datas.many_antifake_msg){
              msg = this.datas.many_antifake_msg;
            }
            self.isShow = true;
            self.hintTxt = msg;
            if(msg && this.datas.antifake_auto){
              try {
                this.speaker = new Speaker({ text: msg });
                if(this.speaker){
                  setTimeout(()=>{
                    this.speaker.start(); // 开时播放
                  },300)
                }
              } catch (error) {
                console.log(error);
              }
            }
          } else {
            self.isShow = false;
          }
        }).catch(function (error) {
          self.hintTxt = "防伪码错误！";
          self.isShow = false;
          self.vcode = '';
        })
    },
    CloseTip() {
      self.hintTxt = null;
    },
    initVideo() {
      //初始化视频方法
      let myPlayer = this.$video(VideoBox, {
        controls: true,  //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        autoplay: false,  //自动播放属性,muted:静音播放
        preload: "auto",  //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      });
    },
    ViewMore(datas) {
      if (self.code) {
        this.$router.push({ path: "/ScanCodeRecord" }); // 模板路由跳转
      } else {
        alert("真实码标数据才能查看扫码记录！");
      }
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu(data) {
      if (data.type != 2) {
        window.location.href = data.url;
      } else {
        this.$router.push({ path: "/qr?qr=" + data.qr });
      }
    }
  }
}
</script>

<style scoped>
.topNo{
  margin-top: 0 !important;
}
.header {
  border-top: 3px solid #5691bc;
  padding: 5px 0px;
  position: relative;
  box-shadow: 0 1px 3px rgb(0 0 0 / 20%);
}

.logo {
  margin-left: 15px;
  width: 70px;
  height: 70px;
}

.logo img {
  display: block;
  width: 100%;
}

.phone {
  box-shadow: 0 1px 0 rgb(255 255 255 / 30%);
  display: inline-block;
  vertical-align: middle;
  position: relative;
  text-align: center;
  border-radius: 25px;
  color: #fff;
  font-size: 0.95em;
  cursor: pointer;
  margin: 15px 0px;
  padding: 8px 15px;
  text-decoration: none;
  font-weight: 700;
  position: absolute;
  top: 5px;
  right: 20px;
  font-family: "Arial", "Times New Roman";
  background: #396b9e linear-gradient(#5f9cc5, #396b9e) repeat scroll 0 0;
}
.phone a{
  color: #fff;
  text-decoration: none;
}

.banner {
  border-radius: .25rem;
  overflow: hidden;
  background: #EEE;
}

.banner img {
  display: block;
  width: 100%;
}

.MainBox {
  margin: .3rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  font-size: .58rem;
  border-radius: .25rem;
  background-color: #FFF;
}

.MainTitle {
  color: #FFF;
  padding: .4rem .5rem;
  background: #396b9e linear-gradient(#5f9cc5, #396b9e) repeat scroll 0 0;
}

.MainDatasBox {
  margin: .3rem;
  overflow: hidden;
  border-radius: .25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.MainDatasRow {
  word-break: break-all;
  padding: .4rem .5rem;
  border-bottom: 1px solid #F3F3F3;
}

.MainDatasRow p {
  position: relative;
}

.ProductMain {
  padding: .4rem .5rem;
}

.ProductDatasBox {
  overflow: hidden;
  margin-bottom: .4rem;
}

.ProductImg {
  float: left;
  width: 5rem;
  height: 5rem;
  background-color: #F3F3F3;
}

.ProductDatas {
  float: left;
  margin-left: .5rem;
  width: calc(100% - 5.5rem);
}

.ProductDatas p:first-child {
  margin-top: 0;
}

.ProductDatas p {
  margin-top: .4rem;
}

.ProductCustom li:first-child {
  margin-top: 0;
}

.ProductCustom li {
  margin-top: .4rem;
}

.letter {
  letter-spacing: .19rem;
}

.qckey {
  position: absolute;
  top: 0;
  left: 0;
  width: 2.9rem;
}

.qcImg {
  display: block;
  padding-left: 3rem;
  width: calc(100% - 5rem);
}

.VideoBox {
  width: 100%;
}

.ref {
  border-radius: 0;
}

.MainRefDatasBox {
  /* padding:.5rem; */
}

.MainRefDatasBox li {
  line-height: .9rem;
  font-size: .58rem;
}

.MainRefDatasBox li img {
  display: block;
  width: 100%;
}

.MainMenuRow {
  padding: .5rem;
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid #F3F3F3;
}

.MainMenuRow:last-child {
  border-bottom: 0;
}

.MainMenuIcon {
  float: left;
  width: 2.2rem;
  height: 2.2rem;
  margin-right: .5rem;
  border-radius: .2rem;
}

.MainMenuIcon i {
  display: block;
  width: 2.2rem;
  height: 2.2rem;
}

.MainMenuDatas {
  float: left;
  width: calc(100% - 3.5rem);
}

.MainMenuDatasTit {
  margin-top: .1rem;
  font-size: .58rem;
}

.MainMenuDatasTxt {
  font-size: .55rem;
  color: #666;
  margin-top: .15rem;
}

.MainMenuArrows {
  position: absolute;
  right: .5rem;
  top: calc(50% - .4rem);
  color: #666;
  font-size: .55rem;
}

.CliclStyle:active {
  background: #F6F6F6;
}

.CliclStyle:focus {
  background: #FFF;
}</style>



// WEBPACK FOOTER //
// src/view/Normal03.vue